<template>
    <b-modal
        id="modal-create-assignment"
        ref="modal-create-assignment"
        centered
        ok-title="Aceptar"
        ok-variant="primary"
        cancel-title="Cancelar"
        :title="modalTitle"
        :ok-disabled="disableOkButton"
        @ok="onCreateUpdate"
        @hidden="resetForm()"
    >
        <b-form id="assignment-form" @submit.stop.prevent="onSubmit()">
            <b-form-group
                id="input-group-assignment-name"
                label="*Nombre:"
                label-for="input-assignment-name"
            >
                <b-form-input
                    id="input-assignment-name"
                    v-model.trim="$v.form.name.$model"
                    name="name"
                    type="text"
                    required
                    :state="validateState('name')"
                    :disabled="formDisabled"
                />
                <b-form-invalid-feedback id="input-assignment-name-feedback">
                    <ul>
                        <li v-if="!$v.form.name.required">Este campo es requerido.</li>
                    </ul>
                </b-form-invalid-feedback>
            </b-form-group>

            <b-row>
                <b-col cols="12" md="6">
                    <b-form-group
                        id="input-group-assignment-deadlineDate"
                        label="*Fecha maxima de Entrega:"
                        label-for="input-assignment-deadlineDate"
                    >
                        <b-form-datepicker
                            id="input-assignment-deadlineDate"
                            v-model="$v.form.deadlineDate.$model"
                            placeholder="Seleccione una fecha..."
                            locale="es-ES"
                            :max="maxInputDates"
                            :state="validateState('deadlineDate')"
                            :disabled="formDisabled"
                            :date-format-options="dateInputFormat"
                            reset-button
                            hide-header
                        />
                        <b-form-invalid-feedback id="input-assignment-deadlineDate">
                            <ul>
                                <li v-if="!$v.form.deadlineDate.required">Este campo es requerido.</li>
                            </ul>
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group
                        id="input-group-assignment-maxSize"
                        label="*Tamaño Máximo:"
                        label-for="input-assignment-maxSize"
                        description="Tamaño máximo del archivo en megabytes"
                    >
                        <b-form-select
                            id="input-assignment-maxSize"
                            name="maxSize"
                            v-model="form.maxSize"
                            :disabled="formDisabled"
                            :options="maxSizeOptions"
                        />
                    </b-form-group>
                </b-col>
            </b-row>

        </b-form>
    </b-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapState, mapGetters, mapActions } from 'vuex'
import { nowLocalDateObject } from '@/helpers.js'

export default {
    name: 'AssignmentCreateUpdateModal',
    data () {
        return {
            formDisabled: false,
            modalTitle: 'Agregar Nueva Entrega',
            maxSizeOptions: [
                {
                    text: '2MB',
                    value: 2 * 1024 * 1024
                },
                {
                    text: '5MB',
                    value: 5 * 1024 * 1024
                },
                {
                    text: '7MB',
                    value: 7 * 1024 * 1024
                },
                {
                    text: '10MB',
                    value: 10 * 1024 * 1024
                }
            ],
            dateInputFormat: {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            },
            form: {
                assignmentId: null,
                name: '',
                deadlineDate: '',
                maxSize: 2 * 1024 * 1024
            },
            oldForm: {
                name: '',
                deadlineDate: '',
                maxSize: 2 * 1024 * 1024
            }
        }
    },
    validations: {
        form: {
            name: {
                required
            },
            deadlineDate: {
                required
            }
        }
    },
    computed: {
        ...mapState([
            'activeSite',
            'selectedCrudObject'
        ]),
        ...mapGetters([
            'getActiveSiteIdentifiers'
        ]),
        disableOkButton () {
            if (this.selectedCrudObject) {
                return this.formDisabled || this.$v.form.$invalid ||
                (this.form.name === this.oldForm.name &&
                this.form.deadlineDate === this.oldForm.deadlineDate &&
                this.form.maxSize === this.oldForm.maxSize)
            } else {
                return this.formDisabled || this.$v.form.$invalid
            }
        },
        maxInputDates () {
            // The maximum allowed dates are from the current date until 2 years later
            var maxDate = nowLocalDateObject()
            maxDate.setFullYear(maxDate.getFullYear() + 2)
            return maxDate
        }
    },
    watch: {
        selectedCrudObject (val, oldVal) {
            // If selectedCrudObject is given a value then the form enters Update mode
            // otherwise the form will always be in Create mode
            if (val) {
                this.modalTitle = 'Editar Entrega'
                this.form.assignmentId = this.selectedCrudObject.id
                this.form.name = this.oldForm.name = this.selectedCrudObject.name
                this.form.deadlineDate = this.oldForm.deadlineDate = this.selectedCrudObject.deadlineDate
                this.form.maxSize = this.oldForm.maxSize = this.selectedCrudObject.maxSize
            } else {
                this.resetForm()
            }
        }
    },
    methods: {
        ...mapActions([
            'createSiteAssignment',
            'updateSiteAssignment'
        ]),
        validateState (name) {
            const { $dirty, $error } = this.$v.form[name]
            return $dirty ? !$error : null
        },
        async onCreateUpdate (bvModalEvt) {
            bvModalEvt.preventDefault() // Prevent modal from closing
            await this.onSubmit() // Trigger submit handler
        },
        resetForm () {
            this.modalTitle = 'Agregar Nueva Entrega'
            this.form.assignmentId = null
            this.form.name = this.oldForm.name = ''
            this.form.deadlineDate = this.oldForm.deadlineDate = ''
            this.form.maxSize = this.oldForm.maxSize = 2 * 1024 * 1024
            this.$v.$reset()
            this.$store.commit('RESET_SELECTED_CRUD_OBJECT')
        },
        async onSubmit () {
            let loader = null
            try {
                this.formDisabled = true
                loader = this.$root.$loading.show()
                const payloadData = { ...this.form, courseSiteId: this.activeSite.id }
                if (this.selectedCrudObject) {
                    // Update mode
                    await this.updateSiteAssignment(payloadData)
                    this.$root.infoToast(`Entrega editada.`)
                } else {
                    // Create mode
                    await this.createSiteAssignment(payloadData)
                    this.$root.successToast(`Entrega creada exitosamente.`)
                }
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-create-assignment')
                })
                this.resetForm()
                // Emitt event to reload the assignments data by the parent component
                this.$emit('reloadAssignmentData')
            } catch (err) {
                console.log({ err: err })
                if (err.response && (err.response.status === 404 || err.response.status === 400)) {
                    this.$root.dangerToast('Datos incorrectos, vuelva a intentar.')
                } else {
                    this.$root.unknownErrorToast()
                }
            } finally {
                this.formDisabled = false
                loader.hide()
            }
        }
    }
}
</script>
